module.exports = __webpack_public_path__ + "img/haleakala.52cc78e4.jpg";